
import Vue from "vue";
import {
  NewTenantUsersApiFunc,
  NewWebsitesApiFunc,
  setAccessToken,
} from "@/api";
import { TenantUser, Website } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import TenantUserEditor from "./components/TenantUserEditor.vue";

type DataType = {
  websites: Array<Website>;
};

export default Vue.extend({
  name: "TenantUserCreateScreen",

  data(): DataType {
    return {
      websites: [],
    };
  },

  mounted() {
    this.fetchWebsites();
  },

  components: {
    TheTemplate,
    BaseCloseButton,
    TenantUserEditor,
  },

  computed: {},

  methods: {
    async fetchWebsites(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({});
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewWebsitesApiFunc().listWebsites(
        companyId,
        filterString
      );

      if (err != null) {
        this.$handleApiError(err, this.fetchWebsites);
        return;
      }

      this.websites = data.list;
    },

    async createTenantUser(tenantUser: TenantUser): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewTenantUsersApiFunc().createTenantUser(
        companyId,
        tenantUser
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.createTenantUser(tenantUser);
        });
        this.$setLoading(false);
        return;
      }
      if (data?.id === undefined) {
        this.$handleApiError(undefined, () => {
          this.createTenantUser(tenantUser);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-tenant-users",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
